export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/digital-pattern.4bb3216.svg";